import axios from '../axios';
const END_POINT = '/medical-specialties';

const addMedicalSpecialty = (medicalSpecialties) => axios.post(`${END_POINT}`, medicalSpecialties);
const getMedicalSpecialties = (payload) => axios.get(`${END_POINT}?limit=${payload.limit}&page=${payload.page}`);
const getMedicalSpecialty = (medicalSpecialtiesId) => axios.get(`${END_POINT}/${medicalSpecialtiesId}`);
const updateMedicalSpecialty = (medicalSpecialtiesId, payload) => axios.patch(`${END_POINT}/${medicalSpecialtiesId}`, payload);
const searchMedicalSpecialty = (payload) => axios.post(`${END_POINT}/search`, payload);
const deleteMedicalSpecialty = (medicalSpecialtiesId) => axios.delete(`${END_POINT}/${medicalSpecialtiesId}`);

export {
    addMedicalSpecialty,
    getMedicalSpecialties,
    getMedicalSpecialty,
    updateMedicalSpecialty,
    searchMedicalSpecialty,
    deleteMedicalSpecialty
}